export const MYAPI_KEY = process.env.REACT_APP_VIA_MYAPI_KEY;
